import { isProd, isStage } from './env';

const stageConfig = {
  env: 'stage',
  apiUrl: 'https://api-stage.homefi.info/api',
  djangoApiUrl: 'https://api-stage.wingalpha.com/v1.1/api',
  oldDashUrl: 'https://stage.mywifistatus.com',
  rechargeStore: 'homefi-staging.myshopify.com',
  rechargeStorefrontToken:
    'strfnt_5aa4150b8dad080399e0b357966cda936889ecd8df995383236c2a791064b2ce',
  homefiRootUser: 1364,
  googleRecaptchaV2Client: '6LdFVYkpAAAAAEuhD6078JKSX9DEMCzRVb5Rn6w8',
};

const localConfig = {
  ...stageConfig,
  env: 'local',
  apiUrl: 'http://127.0.0.1:4001/api',
};

const prodConfig = {
  env: 'prod',
  apiUrl: 'https://api.homefi.info/api',
  djangoApiUrl: 'https://api.wingalpha.com/v1.1/api',
  oldDashUrl: 'https://mywifistatus.com',
  rechargeStore: 'homefinow.myshopify.com',
  rechargeStorefrontToken:
    'strfnt_58b4ca646f777e9438592318a1993a2430a3245e29902b5d652a9564647e7031',
  homefiRootUser: 202014,
  googleRecaptchaV2Client: '6LcxNJUpAAAAAJ06cPLsV1ve9kAoUDxQy8H4OidK',
};

const getConfig = () => {
  if (isProd()) return prodConfig;
  if (isStage()) return stageConfig;
  return localConfig;
};
const config = getConfig();

export default config;

export const API_URL = config.apiUrl;
export const DJANGO_API_URL = config.djangoApiUrl;
export const OLD_DASH_URL = config.oldDashUrl;
export const RECHARGE_STORE_IDENTIFIER = config.rechargeStore;
export const RECHARGE_STOREFRONT_TOKEN = config.rechargeStorefrontToken;
export const HOMEFI_ROOT_USER = config.homefiRootUser;
export const GOOGLE_RECAPTCHA_V2_CLIENT = config.googleRecaptchaV2Client;
